
import { del, get, post, put } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"


export const getUserStatusDefinitions = () => get(url.USER_STATUS_DEFINITIONS)